import { FilterInput, FilterSelectNative } from '@/components/custom/filter';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Loader } from '@/components/custom/loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import EndScroll from '@/components/custom/end-scroll/end-scroll';
import { useSession } from '@/hooks/useSession';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { CardChallenged, CardChallengedName, CardChallengedProfile, CardChallengedWrapper } from '@/components/ui/card';

export function DuelsNew({ open, taxonomies, selectedOpponent, setSelectedOpponent, duelForm }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [students, setStudents] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const debounceTimer = useRef(null);
  const client = useClient();
  const { session } = useSession();

  const getStudents = async () => {
    let url = `users?page[number]=${pageNumber}&page[size]=15`;
    if (searchTerm.length > 0) {
      url += `&q[name_or_email_cont_any]=${searchTerm}`;
    }
    const { data, error } = await client.fetch(url);
    if (error) {
      toast.error(t('toast.errorGetStudents'));
    } else {
      if (data.length < 15) {
        setHasMore(false);
      }
      const students = data.filter(student => student.id !== session.user.id);
      setStudents(prev => (pageNumber === 1 ? students : [...prev, ...students]));
    }
  };

  const filteredStudents = students?.filter(student => student?.name?.toLowerCase().includes(searchTerm?.toLowerCase()));

  useEffect(() => {
    if (open) {
      getStudents();
    }
    if (open === false) {
      setSearchTerm('');
      setStudents([]);
      setPageNumber(1);
    }
  }, [open]);

  useEffect(() => {
    if (selectedOpponent) {
      duelForm.setFieldValue('invited-id', selectedOpponent.id);
    }
  }, [selectedOpponent]);

  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      if (searchTerm.length > 0) {
        setPageNumber(1);
        setHasMore(true);
      }
      setStudents([]);
      getStudents();
    }, 500);
  }, [searchTerm]);

  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
  }, []);

  useEffect(() => {
    getStudents();
  }, [pageNumber]);

  return (
    <DialogContent size="lg">
      <DialogTitle border>Novo duelo</DialogTitle>

      <form onSubmit={duelForm.handleSubmit}>
        <div className="mb-5 space-y-5">
          <FilterSelectNative
            blankLabel={t('filter.blankLabelAll2')}
            label={`*${t('filter.selectTopic')}`}
            value={duelForm.values.topic}
            onChange={e => duelForm.setFieldValue('topic', e.target.value)}
            options={taxonomies}
            hasError={duelForm.touched.topic && duelForm.errors.topic}
            errorText={duelForm.errors.topic}
          />

          <FilterInput
            fullWidth
            label="*Buscar um amigo(a)"
            placeholder={t('textsCommon.research')}
            type="search"
            name="search"
            id="search"
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>

        {/* {loadingStudents && <Loader />} */}

        {!duelForm?.values?.['invited-id'] && (
          <CardChallengedWrapper id="scrollable">
            <InfiniteScroll
              dataLength={filteredStudents.length}
              hasMore={hasMore}
              next={() => setPageNumber(pageNumber + 1)}
              loader={<Loader />}
              endMessage={<EndScroll />}
              scrollableTarget="scrollable"
            >
              {filteredStudents?.map(student => (
                <CardChallenged key={student?.id}>
                  <CardChallengedProfile>
                    <AvatarWrapper
                      src={student?.image.url}
                      text={student?.name}
                    />
                    <CardChallengedName>{student?.name}</CardChallengedName>
                  </CardChallengedProfile>

                  <Button
                    variant="link"
                    onClick={() => setSelectedOpponent({ id: student?.id, name: student?.name, image: student?.image?.url })}
                  >
                    Selecionar
                  </Button>
                </CardChallenged>
              ))}
            </InfiniteScroll>
          </CardChallengedWrapper>
        )}

        {duelForm?.values?.['invited-id'] && (
          <>
            <CardChallenged
              key={duelForm.values.challenged?.id}
              isSelected
            >
              <CardChallengedProfile>
                <AvatarWrapper
                  src={selectedOpponent?.image}
                  text={selectedOpponent?.name}
                />
                <CardChallengedName>{selectedOpponent?.name}</CardChallengedName>
              </CardChallengedProfile>

              <Button
                variant="link"
                onClick={() => setSelectedOpponent({})}
              >
                Remover
              </Button>
            </CardChallenged>

            <Button
              wide
              className="mt-2"
            >
              Desafiar
            </Button>
          </>
        )}
      </form>
    </DialogContent>
  );
}
